// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Lora', 'Lora Fallback', Georgia, Times, Times New Roman, serif","fontWeight":400,"fontStyle":"italic"},"className":"__className_cff0ce"};